import { Constants } from '@utils/constants';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html'
})
export class EmptyResultComponent implements OnInit {

  @Input() message = Constants.MSG_NO_DATA_TO_SHOW;
  @Input() complement = '';
  @Input() icon = 'ico-warning-octagon';

  constructor() { }

  ngOnInit() {
  }

}
